import React, {useEffect, useState} from 'react';
import Input from '../Components/Input';
import Button from '../Components/Button';
import { Link } from 'react-router-dom';


import classes from '../Pages/Registration.module.css'

import SvgPatternBackground from '../Components/svgPatternBackground';

import { GoogleLogin } from '@react-oauth/google';
import jwt_decode from "jwt-decode";


export default function Registration(props) {
    const [pageContent, setPageContent] = useState({})

    const [user, setUser] = useState({
        username: "",
        name: "",
        lastname: "",
        email: "",
        pwd: "",
        picture: "data:image/png;base64,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",
  
    })

    const [enteredNameTouched, setEnteredNameTouched] = useState(false);
    const [enteredLastNameTouched, setEnteredLastNameTouched] = useState(false);
    const [enteredUserNameTouched, setEnteredUserNameTouched] = useState(false);
    const [enteredEmailTouched, setEnteredEmailTouched] = useState(false);
    const [enteredPwdTouched, setEnteredPwdTouched] = useState(false);

    const initError = {
        exists: false,
        helperText: null,
    };

    const [nameError, setNameError] = useState(initError);
    const [lastNameError, setLastNameError] = useState(initError);
    const [userNameError, setUserNameError] = useState(initError);
    const [emailError, setEmailError] = useState(initError);
    const [pwdError, setPwdError] = useState(initError);

    const [passwordCheck, setPasswordCheck] = useState("")
    const [passCheck, setPassCheck] = useState({
        longEnough: false,
        specialCharacter: false,
        number: false,
        capitalLetter: false,
        match: false
    })

    const [passwordShown, setPasswordShown] = useState(false);
    const [passwordCheckShown, setPasswordCheckShown] = useState(false);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_STRAPI_URL}api/register-page/?locale=${props.language}`, { 
            'Content-Type': 'application/json' , method: 'GET' 
            })
            .then(data => data.json())
            .then(data => {
                setPageContent(data.data.attributes)
            })
    }, [props.language])

    useEffect(() => {
        if (!user.name && enteredNameTouched) {
            setNameError({
              exists: true,
              helperText: `${pageContent.void_name_validation_text}`,
            });
        } else {
            setNameError({
              exists: false,
              helperText: null,
            });
        }
        if (!user.lastname && enteredLastNameTouched) {
            setLastNameError({
              exists: true,
              helperText: `${pageContent.void_last_name_validation_text}`,
            });
        } else {
            setLastNameError({
              exists: false,
              helperText: null,
            });
        }
        if (!user.username && enteredUserNameTouched) {
            setUserNameError({
              exists: true,
              helperText: `${pageContent.void_username_validation_text}`,
            });
        } else {
            setUserNameError({
              exists: false,
              helperText: null,
            });
        }
        
        if (!user.email && enteredEmailTouched) {
            setEmailError({
              exists: true,
              helperText: `${pageContent.void_email_validation_text}`,
            });
        } 
        else if(user.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/) === null && user.email !== '') {
            setEmailError({
                exists: true,
                helperText: `${pageContent.valid_email_validation_text}`,
              });
        } 
        else {
            setEmailError({
              exists: false,
              helperText: null,
            });
        }

        if (!user.pwd && enteredPwdTouched) {
            setPwdError({
              exists: true,
              helperText: `${pageContent.void_password_validation_text}`,
            });
        } else {
            setPwdError({
              exists: false,
              helperText: null,
            });
        }

        if(user.pwd.length >= 8) {
            setPassCheck((prevState) => ({
                ...prevState,
                longEnough: true,
            }))
        } else if(user.pwd.length < 8) {
            setPassCheck((prevState) => ({
                ...prevState,
                longEnough: false,
            }))
        } 

        if (user.pwd.match(/[A-Z]/)!== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                capitalLetter: true,
            }))
        } else if (user.pwd.match(/[A-Z]/)=== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                capitalLetter: false,
            }))
        }

        if (user.pwd.match(/[0-9]/)!== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                number: true,
            }))
        } else if (user.pwd.match(/[0-9]/)=== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                number: false,
            }))
        }

        if (user.pwd.match(/[`~!@#$%\^&*()+=|;:'",.<>\/?\\\-]/)!== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                specialCharacter: true,
            }))
        } else if (user.pwd.match(/[`~!@#$%\^&*()+=|;:'",.<>\/?\\\-]/)=== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                specialCharacter: false,
            }))
        }

        if(user.pwd == passwordCheck && user.pwd !== "") {
            setPassCheck((prevState) => ({
                ...prevState,
                match: true,
            }))
        } else if(user.pwd != passwordCheck) {
            setPassCheck((prevState) => ({
                ...prevState,
                match: false,
            }))
        } 

        setPasswordCheck(document.getElementById("pwdCheck").value)


        
    
    }, [user, enteredNameTouched, enteredLastNameTouched, enteredUserNameTouched, enteredEmailTouched, enteredPwdTouched, passwordCheck])
 

    const handleChange = (evt) => {
       
        let value = evt.target.value;
        let name = evt.target.name;
        setUser((prevState) => ({
            ...prevState,
            [name]: value,  
        }))
        if(user.pwd.length >= 7) {
            setPassCheck((prevState) => ({
                ...prevState,
                longEnough: true,
            }))
        } 

        if (user.pwd.match(/[A-Z]/) !== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                capitalLetter: true,
            }))
        }

        if (user.pwd.match(/[0-9]/)!== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                number: true,
            }))
        } 
        if (user.pwd.match(/[`~!@#$%\^&*()+=|;:'",.<>\/?\\\-]/)!== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                specialCharacter: true,
            }))
        }
        if(user.pwd == passwordCheck && user.pwd !== "") {
            setPassCheck((prevState) => ({
                ...prevState,
                match: true,
            }))
        } 
        console.log(user.pwd, passwordCheck, user.pwd === passwordCheck)
    }

    const handleChangePassCheck = (evt) => {
        let value = evt.target.value;
        setPasswordCheck(value)
        if(user.pwd == passwordCheck && user.pwd !== "") {
            setPassCheck((prevState) => ({
                ...prevState,
                match: true,
            }))
        } 
        // console.log(user.pwd, passwordCheck, user.pwd === passwordCheck)

    }
    

    const nameIsValid = !nameError.exists && enteredNameTouched;
    const lastNameIsValid = !lastNameError.exists && enteredLastNameTouched;
    const userNameIsValid = !userNameError.exists && enteredUserNameTouched;
    const emailIsValid = !emailError.exists && enteredEmailTouched;
    const pwdIsValid = !pwdError.exists && enteredPwdTouched;

    const nameBlurHandler = (e) => {
        setEnteredNameTouched(true);
    };

    const lastNameBlurHandler = (e) => {
        setEnteredLastNameTouched(true);
    };

    const userNameBlurHandler = (e) => {
        setEnteredUserNameTouched(true);
    };

    const emailBlurHandler = (e) => {
        setEnteredEmailTouched(true);
        if(user.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/) === null){
            setEmailError({
                exists: true,
                helperText: `${pageContent.valid_email_validation_text}`,
              });
        } else {
            setEmailError({
              exists: false,
              helperText: null,
            });
        }
    };

    const pwdBlurHandler = (e) => {
        setEnteredPwdTouched(true);
    };

    const handleSubmit = (evt) => {
        evt.preventDefault();
        console.log(passCheck.number)

        setEnteredNameTouched(true);
        setEnteredLastNameTouched(true);
        setEnteredUserNameTouched(true);
        setEnteredEmailTouched(true);
        setEnteredPwdTouched(true);

        if(!passCheck.capitalLetter&& user.pwd !== '' || !passCheck.longEnough && user.pwd !== ''|| !passCheck.match&& user.pwd !== '' || !passCheck.number&& user.pwd !== '' || !passCheck.specialCharacter && user.pwd !== '') {
            setPwdError({
                exists: true,
                helperText: `${pageContent.valid_bottom_requirements_validation_text}`,
              });
          }else if (!user.pwd && enteredPwdTouched) {
            setPwdError({
              exists: true,
              helperText: `${pageContent.void_password_validation_text}`,
            });
        } 
          else {
              setPwdError({
                exists: false,
                helperText: null,
              });
          }
        


        if (!passCheck.capitalLetter) {
            return;
        }

        if (!passCheck.longEnough) {
            return;
        }

        if (!passCheck.match) {
            return;
        }

        if (!passCheck.number) {
            return;
        }

        if (!passCheck.specialCharacter) {
            return;
        }

        if (!nameIsValid) {
            return;
        }
        if (!lastNameIsValid) {
            return;
        }
        if (!userNameIsValid) {
            return;
        }
        if (!emailIsValid) {
            return;
        }
        if (!pwdIsValid) {
            return;
        }
        

        Promise.all([
            fetch(`${process.env.REACT_APP_API_GOLANG_URL}/v1/verifyuser/${user.username}`).then(data => data.json()),
            fetch(`${process.env.REACT_APP_API_GOLANG_URL}/v1/verifyemail/${user.email}`).then(data => data.json())
        ])
            .then(data=> {
                console.log(data)
                console.log(data[0].ID)
                console.log(data[1].ID)
                if(data[0].ID === 0 && data[1].ID === 0){
                    const requestOptions = {
                        method: "POST",
                        body: JSON.stringify(user),
                    };

                    if (props.language === 'de') {
                        fetch(`${process.env.REACT_APP_API_GOLANG_URL}/v1/register/`, requestOptions)
                        .then(response => response.json())
                        .then(data => {
                            
                            if(data.error){
                                console.log("Error");
                            }else{
                                console.log(data);
                                window.location.href='/confirmationRegistermail'
                            }
                        });
                    } else {
                        fetch(`${process.env.REACT_APP_API_GOLANG_URL}/v1/registerEN/`, requestOptions)
                        .then(response => response.json())
                        .then(data => {
                            
                            if(data.error){
                                console.log("Error");
                            }else{
                                console.log(data);
                                window.location.href='/confirmationRegistermail'
                            }
                        });
                    }
                }
                else if(data[1].ID !== 0) {
                    let oldUser = {
                        ...user,
                        id: `${data[1].ID}`,
                    }
                   
                    const requestOptions2 = {
                        method: 'POST', 
                        body: JSON.stringify(oldUser),
                    }
                    if(props.language === "de") {
                        fetch(`${process.env.REACT_APP_API_GOLANG_URL}/v1/updateuser/`, requestOptions2)
                            .then(data => window.location.href='/confirmationRegistermail')
                    } else{
                        fetch(`${process.env.REACT_APP_API_GOLANG_URL}/v1/updateuserEN/`, requestOptions2)
                            .then(data => window.location.href='/confirmationRegistermail')
                    }
                }
                else if(data[0].ID !== 0 && data[1].ID === 0) {
                    setUserNameError({
                        exists: true,
                        helperText: `${pageContent.in_use_username_validation_text}`,
                    });
                }
             
            })
         

        

    };
    
    const togglePasswordVisibility = () => {
        setPasswordShown(passwordShown ? false : true);
    };

    const togglePasswordCheckVisibility = () => {
        setPasswordCheckShown(passwordCheckShown ? false : true);
    };

    return(
        <>
        <div className={classes.RegistrationContainerContainer}>
            <div className={classes.RegistrationBox}  >  
                <div style={{height:'5%', borderRadius:'16px 16px 0 0'}}>
                    <SvgPatternBackground borderRadius={'16px 16px 0 0'} scale={3} number={1} height={'4vh'} color={'cad051'} angle={-45}/>
                </div>
                <div className={classes.RegistrationContainer} >
                    <div className={classes.Registration}>
                            <div style={{display:'flex', alignItems:'center'}}>
                                <h3 style={{margin:'0'}}>
                                    {/* {
                                        props.language === "de"
                                        ?
                                        <>Anmeldeformular</>
                                        :
                                        <>Registration form</>
                                    }  */}
                                    {pageContent.form_title}
                                </h3>
                            </div>
                            <div>
                                <form style={{display:'grid', justifyContent:'center'}} onSubmit={handleSubmit}>
                                    <div >
                                        <Input 
                                            title = {"Name"}
                                            type = {"text"}
                                            name = {"name"}
                                            placeholder = {`${pageContent.name_placeholder}`}
                                            value = {user.name}
                                            handleChange = {handleChange}
                                            handleBlur={nameBlurHandler}
                                            className={nameError.exists ? "is-invalid": ""}
                                            errorDiv = {nameError.exists ? "text-danger" : "no-danger"}
                                            errorMsg = {nameError.helperText}
                                        />
                                    </div>
                                    <div >
                                        <Input 
                                            title = {"LastName"}
                                            type = {"text"}
                                            name = {"lastname"}
                                            placeholder = {`${pageContent.last_name_placeholder}`}
                                            value = {user.lastname}
                                            handleChange = {handleChange}
                                            handleBlur={lastNameBlurHandler}
                                            className={lastNameError.exists ? "is-invalid": ""}
                                            errorDiv = {lastNameError.exists ? "text-danger" : "no-danger"}
                                            errorMsg = {lastNameError.helperText}
                                        />
                                    </div>
                                    <div >
                                        <Input 
                                            title = {"UserName"}
                                            type = {"text"}
                                            name = {"username"}
                                            placeholder = {`${pageContent.username_placeholder}`}
                                            value = {user.username}
                                            handleChange = {handleChange}
                                            handleBlur={userNameBlurHandler}
                                            className={userNameError.exists ? "is-invalid": ""}
                                            errorDiv = {userNameError.exists ? "text-danger" : "no-danger"}
                                            errorMsg = {userNameError.helperText}
                                        />
                                    </div>
                                    <div >
                                        <Input 
                                            title = {"Email"}
                                            type = {"text"}
                                            name = {"email"}
                                            placeholder = {`${pageContent.email_placeholder}`}
                                            value = {user.email}
                                            handleChange = {handleChange}
                                            handleBlur={emailBlurHandler}
                                            className={emailError.exists ? "is-invalid": ""}
                                            errorDiv = {emailError.exists ? "text-danger" : "no-danger"}
                                            errorMsg = {emailError.helperText}
                                        />
                                    </div>
                                    <div style={{position:'relative', width:'235px'}}>
                                        <Input
                                            title = {"Password"}
                                            name = {"pwd"}
                                            placeholder = {`${pageContent.new_password_placeholder}`}
                                            value = {user.pwd}
                                            handleChange = {handleChange}
                                            type={passwordShown ? "text" : "password"}
                                            handleBlur={pwdBlurHandler}
                                            className={pwdError.exists ? "is-invalid": ""}
                                            errorDiv = {pwdError.exists ? "text-danger" : "no-danger"}
                                            errorMsg = {pwdError.helperText}
                                            
                                        />
                                        <i style={{position: 'absolute', top:'8px', right:'15px', cursor:'pointer'}} onClick={togglePasswordVisibility}>{passwordShown ? EyeLogo() : EyeLogoClosed()}</i>
                                    </div>
                                    <div style={{position:'relative', width:'235px'}}>
                                        <Input
                                            title = {"PasswordCheck"}
                                            type={passwordCheckShown ? "text" : "password"}
                                            name = {"pwdCheck"}
                                            id = {"pwdCheck"}
                                            placeholder = {`${pageContent.confirm_password_placeholder}`}
                                            value = {passwordCheck}
                                            handleChange = {handleChangePassCheck}
                                        />
                                        <i style={{position: 'absolute', top:'8px', right:'15px', cursor:'pointer'}} onClick={togglePasswordCheckVisibility}>{passwordCheckShown ? EyeLogo() : EyeLogoClosed()}</i>
                                    </div>
                                    <div>
                                        <div style={{fontSize:'14px', fontFamily:'sans-serif'}}>
                                            <div className={classes.RegistrationPWCheckItem} style={{display:'flex', alignItems:'center'}}>
                                                <span style={{marginRight: '10px'}}>{passCheck.longEnough ? passed() : notPassed()}</span>
                                                <p style={{color: passCheck.longEnough ? '#292929' : '#A5A5A5'}}>
                                                    {/* {
                                                        props.language === "de"
                                                        ?
                                                        <>Das Passwort besteht aus mehr als 8 Zeichen.</>
                                                        :
                                                        <>Password has more than 8 characters.</>
                                                    }  */}
                                                    {pageContent.p_requeriments_1}
                                                </p>
                                            </div>
                                            <div className={classes.RegistrationPWCheckItem} style={{display:'flex'}}>
                                                <span style={{marginRight: '10px'}}>{passCheck.capitalLetter ? passed() : notPassed()}</span>
                                                <p style={{color: passCheck.capitalLetter ? '#292929' : '#A5A5A5'}}>
                                                    {/* {
                                                        props.language === "de"
                                                        ?
                                                        <>Das Passwort hat einen Großbuchstaben.</>
                                                        :
                                                        <>Password has a capital letter.</>
                                                    }  */}
                                                    {pageContent.p_requeriments_2}
                                                </p>
                                            </div> 
                                            <div className={classes.RegistrationPWCheckItem} style={{display:'flex'}}>
                                                <span style={{marginRight: '10px'}}>{passCheck.number ? passed() : notPassed()}</span>
                                                <p style={{color: passCheck.number ? '#292929' : '#A5A5A5'}}>
                                                    {/* {
                                                        props.language === "de"
                                                        ?
                                                        <>Das Passwort hat eine Nummer.</>
                                                        :
                                                        <>Password has a number.</>
                                                    }  */}
                                                    {pageContent.p_requeriments_3}
                                                </p>
                                            </div>
                                            <div className={classes.RegistrationPWCheckItem} style={{display:'flex'}}>
                                                <span style={{marginRight: '10px'}}>{passCheck.specialCharacter ? passed() : notPassed()}</span>
                                                <p style={{color: passCheck.specialCharacter ? '#292929' : '#A5A5A5'}}>
                                                    {/* {
                                                        props.language === "de"
                                                        ?
                                                        <>Das Passwort hat ein Sonderzeichen.</>
                                                        :
                                                        <>Password has a special character.</>
                                                    }  */}
                                                    {pageContent.p_requeriments_4}
                                                </p>
                                            </div>
                                            <div className={classes.RegistrationPWCheckItem} style={{display:'flex'}}>
                                                <span style={{marginRight: '10px'}}>{passCheck.match ? passed() : notPassed()}</span>
                                                <p style={{color: passCheck.match ? '#292929' : '#A5A5A5'}}>
                                                    {/* {
                                                        props.language === "de"
                                                        ?
                                                        <>Passwörter stimmen überein.</>
                                                        :
                                                        <>Passwords match.</>
                                                    }  */}
                                                     {pageContent.p_requeriments_5}
                                                </p>
                                            </div>
                                        </div>
                                        
                                    </div>
                                            

                                    <div style={{display:'flex', justifyContent:'center', marginTop:'30px'}}>
                                        <Button
                                            title={`${pageContent.register_text}`}
                                            className={"ochre"}
                                        />
                                    </div>
                                </form>
                            </div>

                    </div>
                    <div className={classes.DivisionLine}></div>
                    <div className={classes.RegistrationOtherOptions}>
                        <div style={{display:'grid', height:'min-content', justifyItems:'center'}}>
                            <div className='subtitle'>       
                                {/* {
                                    props.language === "de"
                                    ?
                                    <>oder registrieren Sie sich bei</>
                                    :
                                    <>or register with</>
                                }  */}
                                {pageContent.or_text}
                            </div>
                            <div
                                style={{display: 'flex', justifyContent: 'center', margin: '3rem'}}
                            >
                                <GoogleLogin
                                    onSuccess={credentialResponse => {
                                        console.log(credentialResponse);
                                        var decoded = jwt_decode(credentialResponse.credential);
                                        console.log(decoded)
                                                const requestOptions = {
                                                    method: "POST",
                                                    body: JSON.stringify({
                                                        username: '',
                                                        name: decoded.given_name,
                                                        lastname: decoded.family_name,
                                                        email: decoded.email,
                                                        pwd: '',
                                                        picture:  decoded.picture    
                                                    }),
                                                };
                                                // console.log(requestOptions)

                                                if(props.language === "de") {
                                                    fetch(`${process.env.REACT_APP_API_GOLANG_URL}/v1/googleauth/`, requestOptions)
                                                    .then(response => response.json())
                                                    .then(data => {
                                                        // console.log(data);
                                                        window.localStorage.setItem("jwt", JSON.stringify({...data}.user.token));
                                                        window.localStorage.setItem("id", JSON.stringify(data.user.id));
                                                        props.history.push({
                                                            pathname: "/basicDictionary/0",
                                                        })
                                                    });
                                                } else {
                                                    fetch(`${process.env.REACT_APP_API_GOLANG_URL}/v1/googleauthEN/`, requestOptions)
                                                    .then(response => response.json())
                                                    .then(data => {
                                                        // console.log(data);
                                                        window.localStorage.setItem("jwt", JSON.stringify({...data}.user.token));
                                                        window.localStorage.setItem("id", JSON.stringify(data.user.id));
                                                        props.history.push({
                                                            pathname: "/basicDictionary/0",
                                                        })
                                                    });
                                                }
    
                                                
                                        
                                    }}
                                />
                            </div>

                            <div style={{marginBottom:'30px'}} className='subtitle'>
                                {/* {
                                    props.language === "de"
                                    ?
                                    <>Sie haben ein Konto?</>
                                    :
                                    <>You have an account?</>
                                } */}
                                {pageContent.account_title}
                            </div>
                            <Link
                                to={`/login`}
                                className={'btn snow'}
                            >
                                {pageContent.login_button_text}
                            </Link>
                            
                        </div>
                    </div> 
                </div>
                     

            </div>
        </div>
        </>
    )

}

const notPassed = () => {
    return(
        <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1H10.5" stroke="#B66A00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        
    )
}

const passed = () => {
    return(
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 8L4 11L11 1" stroke="#B66A00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

        
    )
}

const EyeLogo = () => {
    return(
      <svg width="24" height="24" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.0125 15.75C5.94249 15.75 1.5325 12.65 0.0225 8.02997C-0.0075 7.92997 -0.0075 7.81997 0.0225 7.71997C1.5325 3.09997 5.94249 0 11.0125 0C16.0825 0 20.4925 3.09997 22.0025 7.71997C22.0325 7.81997 22.0325 7.92997 22.0025 8.02997C20.4925 12.65 16.0825 15.75 11.0125 15.75ZM1.0225 7.87C2.4425 11.99 6.43249 14.75 11.0125 14.75C15.5925 14.75 19.5825 11.99 21.0025 7.87C19.5825 3.75 15.5925 0.98999 11.0125 0.98999C6.43249 0.98999 2.4425 3.75 1.0225 7.87Z" fill="#B66A00"/>
        <path d="M11.0125 12.7999C8.30251 12.7999 6.09253 10.5899 6.09253 7.87994C6.09253 7.59994 6.31253 7.37994 6.59253 7.37994C6.87253 7.37994 7.09253 7.59994 7.09253 7.87994C7.09253 10.0399 8.85251 11.7999 11.0125 11.7999C13.1725 11.7999 14.9326 10.0399 14.9326 7.87994C14.9326 5.71994 13.1725 3.95996 11.0125 3.95996C10.7325 3.95996 10.5125 3.73996 10.5125 3.45996C10.5125 3.17996 10.7325 2.95996 11.0125 2.95996C13.7225 2.95996 15.9326 5.16994 15.9326 7.87994C15.9326 10.5899 13.7225 12.7999 11.0125 12.7999Z" fill="#B66A00"/>
      </svg>
    )
}

const EyeLogoClosed = () => {
    return(
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.0125 19.75C6.94249 19.75 2.5325 16.65 1.0225 12.03C0.9925 11.93 0.9925 11.82 1.0225 11.72C2.5325 7.09997 6.94249 4 12.0125 4C17.0825 4 21.4925 7.09997 23.0025 11.72C23.0325 11.82 23.0325 11.93 23.0025 12.03C21.4925 16.65 17.0825 19.75 12.0125 19.75ZM2.0225 11.87C3.4425 15.99 7.43249 18.75 12.0125 18.75C16.5925 18.75 20.5825 15.99 22.0025 11.87C20.5825 7.75 16.5925 4.98999 12.0125 4.98999C7.43249 4.98999 3.4425 7.75 2.0225 11.87Z" fill="#B66A00"/>
            <path d="M12.0125 16.7899C9.30251 16.7899 7.09253 14.5799 7.09253 11.8699C7.09253 11.5899 7.31253 11.3699 7.59253 11.3699C7.87253 11.3699 8.09253 11.5899 8.09253 11.8699C8.09253 14.0299 9.85251 15.7899 12.0125 15.7899C12.2925 15.7899 12.5125 16.0099 12.5125 16.2899C12.5125 16.5699 12.2925 16.7899 12.0125 16.7899Z" fill="#B66A00"/>
            <path d="M16.4225 12.3799C16.1425 12.3799 15.9225 12.1599 15.9225 11.8799C15.9225 9.71994 14.1624 7.95996 12.0024 7.95996C11.7224 7.95996 11.5024 7.73996 11.5024 7.45996C11.5024 7.17996 11.7224 6.95996 12.0024 6.95996C14.7124 6.95996 16.9225 9.16994 16.9225 11.8799C16.9225 12.1599 16.7025 12.3799 16.4225 12.3799Z" fill="#B66A00"/>
            <path d="M19.1426 19.51C19.0126 19.51 18.8826 19.46 18.7926 19.36L4.53257 5.09995C4.33257 4.89995 4.33257 4.58999 4.53257 4.38999C4.73257 4.18999 5.04259 4.18999 5.24259 4.38999L19.5025 18.65C19.7025 18.85 19.7025 19.16 19.5025 19.36C19.4025 19.46 19.2726 19.51 19.1526 19.51H19.1426Z" fill="#B66A00"/>
        </svg>
    )
}